import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import Media from "../../core/media";
var ContentCardMediaMain = createComponent({
  displayName: 'ContentCardMediaMain',
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
  },
  defaultProps: {
    children: undefined
  },
  render: function render(p) {
    return p.children ? /*#__PURE__*/React.createElement("div", {
      className: "content-card-media-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-media-main__inner"
    }, /*#__PURE__*/React.isValidElement(p.children) ? p.children : /*#__PURE__*/React.createElement(Media, {
      reference: p.children
    }))) : null;
  }
});
export default ContentCardMediaMain;
//# sourceMappingURL=content-card-media-main.js.map